import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import TransitionsModal from './RequestBillModal';
import * as ApiCall from '../ApiCall.jsx';

//footer for the bill page, when button pressed will close the users session
export default function RequestBillFooter(props) {

  //states [reviewing, success]
  //set state = reviewing, by default
  const [state, setState] = React.useState('reviewing');
  const cId = localStorage.getItem('customerId');
  const total = parseFloat(props.orderTotal, 10);
  
  function handleRequestBill() {
    //when the button is pressed api cal lto add to stuff to the billing backend
    //change to success when suceed with that
    setState('sending');
    //do api stuff
      //on success set state success
    ApiCall.get("/customers/on_request_bill", "cID="+cId)
    .then((stuff) => {
      setState('success');
      localStorage.clear('customerId');
    })
    .catch((msg) => {
      alert("Failed to confirm order, please try again:" + msg);
      setState('reviewing');
    })

  }

  const handleCloseModal = () => {
    setState('reviewing');
  };

  if (state === 'reviewing') {
    return (
      <Box sx={{ flexShrink: 0, backgroundColor: '#white', bottom: 0, 
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%'}}>
        <Box sx={{ padding: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Typography variant="h6" sx={{fontWeight: "bold"}}>Total: ${total}</Typography>
          <Button variant="contained" sx={{fontSize: "1.1rem", backgroundColor: "black", textTransform: 'none', ':hover': {
                  color: 'white',
                  bgcolor: 'grey'
                } }} onClick={handleRequestBill}>Request Bill</Button>
        </Box>
      </Box>
    )
  }

  else if (state === 'sending') {
    return (
      <Box sx={{ height: 1/5, width: 1, flexShrink: 0, backgroundColor: 'white', bottom: 0, 
                  display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <CircularProgress />
      </Box>
    )
  }

  else if (state === 'success') {
    return (
      <Box sx={{ height: 1/5, width: 1, flexShrink: 0, backgroundColor: 'white', bottom: 0,
                  display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <Typography variant="h6"  align="center" sx={{p: 2, fontWeight: "bold"}}>Bill request has been received, Thanks!</Typography>
        <TransitionsModal open={state === 'success'} onClose={handleCloseModal} />
      </Box>
    )
  }
}